import UsersService from "@/services/UsersService";

const getDefaultState = () => {
    return {
        users: [],
    };
};

export default {
    state: () => getDefaultState(),
    mutations: {
        setUsers: (state, users) => {
            state.users = users;
        },
        setUsersState: state => {
            Object.assign(state, getDefaultState());
        },
    },
    getters: {
        getUsers: state => state.users,
    },
    actions: {
        processUsers: async ({ dispatch, commit }) => {
            try {
                commit("setLoading", true);
                const response = await UsersService.get();
                commit("setUsers", response.data.data);
            } catch (e) {
                if (e.response.data.message === "Objects were not found") {
                    commit("setUsers", []);
                } else {
                    dispatch("generalErrorHandling", e);
                }
            } finally {
                commit("setLoading", false);
            }
        },

        addUser: async ({ dispatch, commit }, user) => {
            try {
                commit("setLoading", true);
                await UsersService.create(user);
                await dispatch("processUsers");
                commit({
                    type: "alert",
                    text: "New user saved",
                    color: "primary",
                    icon: "save",
                });
            } catch (e) {
                dispatch("generalErrorHandling", e);
            } finally {
                commit("setLoading", false);
            }
        },

        getUser: async ({ dispatch, commit }, username) => {
            try {
                commit("setLoading", true);
                const response = await UsersService.getByLdap(username);
                const user = response.data.data[0];
                commit("setUser", user);
                return user;
            } catch (e) {
                dispatch("generalErrorHandling", e);
            } finally {
                commit("setLoading", false);
            }
        },

        editUser: async ({ dispatch, commit }, user) => {
            try {
                commit("setLoading", true);
                await UsersService.update(user.id, user);
                await dispatch("processUsers");
                commit({
                    type: "alert",
                    text: "User changes saved",
                    color: "primary",
                    icon: "save",
                });
            } catch (e) {
                dispatch("generalErrorHandling", e);
            } finally {
                commit("setLoading", false);
            }
        },

        deleteUser: async ({ dispatch, commit }, id) => {
            try {
                commit("setLoading", true);
                await UsersService.delete(id);
                await dispatch("processUsers");
                commit({
                    type: "alert",
                    text: "User deleted",
                    color: "error",
                    icon: "delete_sweep",
                });
            } catch (e) {
                dispatch("generalErrorHandling", e);
            } finally {
                commit("setLoading", false);
            }
        },

        resetUsersState: ({ commit }) => {
            commit("setUsersState");
        },
    },
};
